import { render, staticRenderFns } from "./SmartRewardsRules.vue?vue&type=template&id=075e8988&scoped=true"
import script from "./SmartRewardsRules.vue?vue&type=script&lang=js"
export * from "./SmartRewardsRules.vue?vue&type=script&lang=js"
import style0 from "./SmartRewardsRules.vue?vue&type=style&index=0&id=075e8988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e8988",
  null
  
)

export default component.exports